__turbopack_context__.v({
  "aspectRatioRoundedCorners": "EasySteps-module__fbygdG__aspectRatioRoundedCorners",
  "buttonContainer": "EasySteps-module__fbygdG__buttonContainer",
  "easyStepsContainer": "EasySteps-module__fbygdG__easyStepsContainer",
  "easyStepsItem": "EasySteps-module__fbygdG__easyStepsItem",
  "howItWorksCarouselDots": "EasySteps-module__fbygdG__howItWorksCarouselDots",
  "previousSlide": "EasySteps-module__fbygdG__previousSlide",
  "selected": "EasySteps-module__fbygdG__selected",
  "videoContainer": "EasySteps-module__fbygdG__videoContainer",
  "videoTextContainer": "EasySteps-module__fbygdG__videoTextContainer",
});
